import { type AnyRouter } from '@tanstack/react-router';

export const BASE_URL = new URL(window.location.origin);
export const HOSTNAME = BASE_URL.hostname.replace(/^local\./, '');
export const QDRANT_TECH_URL = new URL(window.__QDRANT_CLOUD__.qdrant_tech_url);
export const AUTH_REDIRECT_URL = new URL('auth/callback', BASE_URL).href;

/** The form field the post-login Action reads the continuation token from (its `tokenParameterName`). */
const CONTINUATION_TOKEN_FIELD = 'continuation_token';

/**
 * Where the OAuth consent page hands the login back to Auth0: `/continue` of the post-login Action's
 * redirect, on the login domain, with the redirect `state` Auth0 put on the consent page URL.
 * Opened without a continuation token (Cancel), the Action denies the login.
 */
export function auth0ContinueUrl(state: string): string {
  const url = new URL('/continue', `https://${window.__QDRANT_CLOUD__.auth0.domain}`);
  url.searchParams.set('state', state);

  return url.href;
}

/**
 * Resumes the login with the continuation token. It is POSTed in a form field, as Auth0 documents,
 * so the token stays out of the URL, the browser history and the `Referer`.
 */
export function submitAuth0Continue(state: string, continuationToken: string): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = auth0ContinueUrl(state);
  form.style.display = 'none';

  const field = document.createElement('input');
  field.type = 'hidden';
  field.name = CONTINUATION_TOKEN_FIELD;
  field.value = continuationToken;

  form.append(field);
  document.body.append(form);
  form.submit();
}

type AssetPath = `static/images/${string}.${'svg' | 'png' | 'jpg'}` | `static/js/${string}.js`;

export function cdnStaticPath(assetPath: AssetPath): string {
  return window.__toCdnUrl(assetPath);
}

export function buildReturnUrl(router: AnyRouter): string {
  const location = router.latestLocation;
  if (!location) {
    return '/';
  }

  const { href } = router.buildLocation({
    to: location.pathname,
    search: location.search as Record<string, string | string[]>,
  });

  return href;
}
